declare global {
  interface Window {
    fbq: any
  }
}

export const CHECKOUT_URL =
  'https://payments.nerovix.online/cart/47845932204291:1'

export const handleCheckout = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }

  // Fire Meta Pixel InitiateCheckout event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }

  // Redirect to checkout
  window.location.href = CHECKOUT_URL
}

export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const el = document.getElementById('purchase')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
